var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSlow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12.8,
    height: 16,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.00015V6.20215V3.79815V1.00015C-2.70837e-05 0.819107 0.0490946 0.641453 0.142125 0.486141C0.235156 0.330829 0.368605 0.203685 0.528234 0.118276C0.687864 0.032866 0.867687 -0.00760575 1.04852 0.00117785C1.22935 0.00996145 1.4044 0.0676712 1.555 0.16815L7.555 4.16815C7.69196 4.25947 7.80425 4.38319 7.88192 4.52833C7.95959 4.67347 8.00023 4.83554 8.00023 5.00015C8.00023 5.16476 7.95959 5.32683 7.88192 5.47197C7.80425 5.61711 7.69196 5.74083 7.555 5.83215L1.555 9.83215C1.4044 9.93263 1.22935 9.99034 1.04852 9.99912C0.867687 10.0079 0.687864 9.96743 0.528234 9.88202C0.368605 9.79661 0.235156 9.66947 0.142125 9.51416C0.0490946 9.35885 -2.70837e-05 9.18119 0 9.00015Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSlow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Slow.4fe2a093b85f2cedc4d8b12f49caf6a9.svg";